"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.xAPIVerb = exports.xAPIObject = void 0;
var xAPIVerb;
exports.xAPIVerb = xAPIVerb;

(function (xAPIVerb) {
  xAPIVerb["Received"] = "received";
  xAPIVerb["Sent"] = "sent";
  xAPIVerb["Subscribed"] = "subscribed";
  xAPIVerb["Unsubscribed"] = "unsubscribed";
  xAPIVerb["Started"] = "started";
  xAPIVerb["Ended"] = "ended";
  xAPIVerb["Joined"] = "joined";
  xAPIVerb["Left"] = "left";
  xAPIVerb["TimedOut"] = "timed-out";
})(xAPIVerb || (exports.xAPIVerb = xAPIVerb = {}));

var xAPIObject;
exports.xAPIObject = xAPIObject;

(function (xAPIObject) {
  xAPIObject["RealtimeMessage"] = "realtime-message";
  xAPIObject["Channel"] = "realtime-channel";
  xAPIObject["Class"] = "class";
})(xAPIObject || (exports.xAPIObject = xAPIObject = {}));
//# sourceMappingURL=interfaces.js.map